import { connect } from 'react-redux'
import * as api from '../store/api'
import CheckTickets from '../components/CheckTickets';

const mapStateToProps = (state) => {
    return {
        client: state.service.client,
        event: state.service.event
    };
}


const mapDispatchToProps = (dispatch) => ({
    getEventPurchases: (eventId, phone, options, callback) => {
        const requestOptions = typeof options === "function" ? {} : (options || {})
        const done = typeof options === "function" ? options : callback
        dispatch(api.getEventPurchases(eventId, phone, requestOptions)).then(done)
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(CheckTickets)
